<template>
  <div>
    <el-dialog
      title="公用资源选择"
      :visible.sync="dialogVisible"
      width="700px;"
      :before-close="handleClose"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
    >
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="广播资源" name="first">
          <div>
            <dialog-table
              :list="resData.list"
              :broadcastBrand="broadcastBrand"
            ></dialog-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="系统广播" name="second">
          <div>
            <dialog-table
              :list="resData.list"
              :broadcastBrand="broadcastBrand"
            ></dialog-table>
          </div>
        </el-tab-pane>
      </el-tabs>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="handleClose">取 消</el-button>
        <el-button size="small" type="primary" @click="submit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import dialogTable from "./RestBroadcastAddOrEditDialogTable.vue";
export default {
  name: "RestBroadcastAddOrEdit",
  components: {
    dialogTable
  },
  props: {
    dialogResize: {
      type: Number,
      default: {
        return: 0
      }
    },
    broadcastBrand: {
      type: Number,
      default: {
        return: 0
      }
    }
  },
  data() {
    return {
      dialogVisible: false,
      activeName: "first",
      resData: {
        list: []
      }
    };
  },
  created() {},
  mounted() {},
  watch: {
    dialogResize: function(newVal, oldVal) {
      if (newVal) {
        this.dialogVisible = true;
        this.getDataList();
      }
    }
  },
  computed: {
    selectBroadcastCatalogIdTemp() {
      return this.$store.state.selectBroadcastCatalogIdTemp;
    },
    selectBroadcastNameTemp() {
      return this.$store.state.selectBroadcastNameTemp;
    }
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
      // console.log(tab.name);
      if (tab.name == "first") {
        this.getDataList();
      } else {
        this.getSystemList();
      }
    },
    handleClose() {
      this.activeName = "first";
      this.dialogVisible = false;
      this.$store.commit("updateSelectBroadcastCatalogIdTemp", "");
      this.$store.commit("updateSelectBroadcastNameTemp", "");
    },
    submit() {
      if (this.selectBroadcastCatalogIdTemp == "") {
        this.$message("请选择资源广播！");
        return;
      }
      this.$store.commit(
        "updateSelectBroadcastCatalogId",
        this.selectBroadcastCatalogIdTemp
      );
      this.$store.commit(
        "updateSelectBroadcastName",
        this.selectBroadcastNameTemp
      );
      this.activeName = "first";
      this.dialogVisible = false;
    },

    // 获取广播资源
    async getDataList() {
      let req = {
        schoolId: this.$store.state.schoolId
      };

      let res = await this.$Http.getBroadcastResources(req);
      if (res.code == 200) {
        this.resData.list = res.data || [];
      } else if (res.code == 101) {
        this.resData.list = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 获取系统列表
    async getSystemList() {
      let req = {};
      let res = await this.$Http.getSystemBroadcast(req);
      // console.log(res)
      if (res.code == 200) {
        this.resData.list = res.data || [];
      } else if (res.code == 101) {
        this.resData.list = [];
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>
<style lang="scss" scoped></style>
